import { klaviyoCatalogSyncJobs } from "../../apiService/blustreamApi";

// getCatalogItems/getCatalogItem (catalog-items) had no beta-API replacement
// when this repoint shipped (ch60569) -- their legacy REST routes were
// already dead (ch60582 removed the backend mappings) and nothing restored
// them. Removed along with the "Synced Catalog Items" browser in
// CatalogSyncTab.js that called them; no story owns bringing this back yet.

export const getSyncJobs = () => klaviyoCatalogSyncJobs.list();

export const getRunningSyncJobs = () => klaviyoCatalogSyncJobs.list({ status: "in_progress" });

export const getSyncJob = (jobId) => klaviyoCatalogSyncJobs.get(jobId);

export const triggerCatalogSync = () => klaviyoCatalogSyncJobs.create();
